"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttondropdown = _interopRequireDefault(require("../../buttondropdown/"));

var _style = require("../functions/style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var HeaderColumn = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderColumn, _React$Component);

  var _super = _createSuper(HeaderColumn);

  function HeaderColumn() {
    _classCallCheck(this, HeaderColumn);

    return _super.apply(this, arguments);
  }

  _createClass(HeaderColumn, [{
    key: "buttonText",
    value: function buttonText(text, sort) {
      var active = this.isColumnBeingSorted(sort);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(active ? 'red' : '', " flex items-center mr1")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "material-icons",
        style: {
          width: '26px',
          fontSize: '18px'
        }
      }, active ? 'check' : ''), text);
    }
  }, {
    key: "getColumnButtonText",
    value: function getColumnButtonText() {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "test-header-sort",
        style: {
          color: '#92999F',
          fontSize: '12px'
        },
        className: "flex items-center regular"
      }, /*#__PURE__*/_react.default.createElement("span", null, this.props.column.text), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: '18px',
          width: '10px',
          height: '15px'
        },
        className: "material-icons ml1 flex items-center justify-center"
      }, "arrow_drop_down"));
    }
  }, {
    key: "isColumnBeingSorted",
    value: function isColumnBeingSorted(sort) {
      return this.props.sorting.direction === sort && this.props.sorting.key === this.props.column.key;
    }
  }, {
    key: "onSortChange",
    value: function onSortChange(value) {
      if (value.direction != this.props.sorting.direction || value.key != this.props.sorting.key) {
        this.props.onSortChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          column = _this$props.column,
          width = _this$props.width,
          anchor = _this$props.anchor;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: (0, _style.getStyle)(width),
        className: "pl2 flex items-center ".concat(width === 'auto' ? 'flex-auto' : '', " __table-header")
      }, column.key ? /*#__PURE__*/_react.default.createElement(_buttondropdown.default, {
        button: {
          className: 'link col-12',
          text: this.getColumnButtonText()
        },
        dropdown: {
          anchor: anchor,
          content: [{
            text: this.buttonText('Ascending', 'ASC'),
            onClick: function onClick() {
              return _this.onSortChange({
                direction: 'ASC',
                key: column.key
              });
            }
          }, {
            text: this.buttonText('Descending', 'DESC'),
            onClick: function onClick() {
              return _this.onSortChange({
                direction: 'DESC',
                key: column.key
              });
            }
          }]
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          color: '#92999F',
          fontSize: '12px',
          cursor: 'default'
        }
      }, column.text));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return HeaderColumn;
}(_react.default.Component);

HeaderColumn.propTypes = {
  column: _propTypes.default.object.isRequired,
  sorting: _propTypes.default.object,
  onSortChange: _propTypes.default.func,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  anchor: _propTypes.default.oneOf(['right', 'left']).isRequired
};
var _default = HeaderColumn;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(HeaderColumn, "HeaderColumn", "/Users/darcy/sites/cs-theme/src/components/table/header/column.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/table/header/column.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();